
import React from 'react';
import { motion } from 'framer-motion';

interface HeroBackgroundProps {
  isHovering: boolean;
}

const HeroBackground = ({ isHovering }: HeroBackgroundProps) => {
  return (
    <div className="absolute inset-0">
      {/* New background image */}
      <div 
        className="absolute inset-0"
        style={{
          backgroundImage: `url('/lovable-uploads/f28d8da6-169b-426a-8fc3-1fa3fd3b7686.png')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      />
      
      {/* Dark overlay for better text readability */}
      <div className="absolute inset-0 bg-black/50" />

      {/* Static gradient overlay - animation removed for performance */}
      <div
        className="absolute inset-0 bg-gradient-to-br from-blue-900/30 via-purple-900/20 to-indigo-900/30"
        style={{ opacity: 0.6 }}
      />

      {/* Particles removed for performance */}
    </div>
  );
};

export default HeroBackground;
